import React, { useState, useRef } from "react";
import MapComponent from "../../components/map";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
  });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    emailjs
      .sendForm(
        "service_oifycf6",
        "template_mq4n2zp",
        formRef.current,
        "EgH1vyh-Fx2rqJ0IH"
      )
      .then(() => {
        setSent(true);
        setFormData({ name: "", email: "", phone: "", company: "", service: "" });
      })
      .catch(() => setError("Failed to send. Please try again."))
      .finally(() => setLoading(false));
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto space-y-4">
      {[
        { id: "name", label: "Name", required: true },
        { id: "email", label: "Email", required: true },
        { id: "phone", label: "Phone Number", required: true },
        { id: "company", label: "Company Name", required: false },
        { id: "service", label: "Request Service", required: true },
      ].map(({ id, label, required }) => (
        <div key={id} className="relative w-full">
          <input
            type="text"
            id={id}
            name={id}
            required={required}
            placeholder=" "
            value={formData[id]}
            onChange={handleChange}
            className="peer w-full px-3 pt-5 pb-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
          <label
            htmlFor={id}
            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-200 transform -translate-y-4 scale-75 top-2.5 left-3 z-10 origin-[0] bg-white px-1 dark:bg-gray-800 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2.5 peer-focus:scale-75 peer-focus:-translate-y-4"
          >
            {label} {required && <span className="text-red-500">*</span>}
          </label>
        </div>
      ))}

      {sent && <p className="text-green-600">Your message has been sent!</p>}
      {error && <p className="text-red-600">{error}</p>}

      <button
        type="submit"
        disabled={loading}
        className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        {loading ? "Sending..." : "Send"}
      </button>
    </form>
  );
};

const IconComponent = ({ IconImagePath, Property, data }) => {
  return (
    <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto">
      <img src={IconImagePath} className="w-6 h-6 sm:w-8 sm:h-8" />
      <div className="text-xs sm:text-sm">
        <p className="font-medium text-xs sm:text-sm">{Property}</p>
        <p className="font-normal text-xs sm:text-sm">{data}</p>
      </div>
    </div>
  );
};

const ContactUs = () => {
  return (
    <section className="py-16 pt-32 bg-[#F4F7F7] px-4 sm:px-6 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-20">
        {/* Left Side: Contact Info + Form */}
        <div className="w-full lg:w-1/2">
          <h3 className="text-3xl sm:text-4xl font-bold">
            Get In <span className="text-[#005CB9]">Touch</span>
          </h3>
          <p className="text-sm sm:text-base mt-4">
            Whether you have a question about any product or service, our team is ready to answer all your questions.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6 mt-5">
            <IconComponent
              IconImagePath={require("../../assets/icons/ContactPhone.png")}
              Property="Phone"
              data="01203000028"
            />
            <IconComponent
              IconImagePath={require("../../assets/icons/ContactLinkedin.png")}
              Property="Linkedin"
              data="h2a medical solutions"
            />
            <IconComponent
              IconImagePath={require("../../assets/icons/ContactMail.png")}
              Property="Mail"
              data="Info@h2amedics.com"
            />
          </div>

          <div className="mt-6 w-full">
            <ContactForm />
          </div>
        </div>

        {/* Right Side: Map */}
        <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
          <div className="w-full aspect-[4/3] sm:aspect-[16/9] lg:aspect-auto">
            <MapComponent lat={30.02156} long={31.07052} />
          </div>
        </div>
      </div>
    </section>
  );
};


export default ContactUs;
